module.exports = __webpack_public_path__ + "static/media/harshita.6f5398b4.jpg";